import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Home from "./views/Home.vue";
import Survey from "./views/Survey.vue";
import SurveyReview from "./views/SurveyReview.vue";
import NotFound from "./views/NotFound.vue";
import Forbidden from "./views/Forbidden.vue";
import Finished from "./views/Finished.vue";
import NoSurvey from "./views/NoSurvey.vue";
import { SCORING_ROUTE_NAMES_BASE, SCORING_CONFIGS } from "./global/global";
import { TOKEN_NAME } from "@/global/global.js";


function httpCodesRoutes() {
  return [
    {
      path: "/",
      alias: "*",
      name: "home",
      component: Home
    },
    {
      path: "/surveys",
      alias: "*",
      name: "surveys",
      component: Survey
    },
    {
      path: "/surveys-review",
      alias: "*",
      name: "surveys-review",
      component: SurveyReview
    },
    {
      path: "/not-found",
      alias: "*",
      name: "notFound",
      component: NotFound
    },
    {
      path: "/forbidden",
      alias: "*",
      name: "forbidden",
      component: Forbidden
    },
    {
      path: "/finished",
      alias: "*",
      name: "finished",
      component: Finished
    },
    {
      path: "/no-survey",
      alias: "*",
      name: "no-survey",
      component: NoSurvey
    }
  ];
}

function getRoutes() {
  let token = localStorage.getItem(TOKEN_NAME);
  if (!token) {
    // Return not logged routes
    return httpCodesRoutes();
  }

  // Logged user, return logged routes
  return httpCodesRoutes();;
}

export default new Router({
  base: process.env.VUE_APP_BASE_CLIENT_URL,
  mode: "history",
  linkExactActiveClass: "nav-item active",
  scrollBehavior: function(to, from, savedPosition) {
    document.getElementsByClassName("main-panel")[0] &&
      document.getElementsByClassName("main-panel")[0].scrollTo(0, 0);
  },
  getRoutes: function() {
    return getRoutes();
  },
  routes: getRoutes()
});
